// extracted by mini-css-extract-plugin
export default {"mark":"RationaleMark_mark__B7i69"};